import { Injectable } from '@angular/core';

import { AuthToken } from '../models/token';

@Injectable()
export class TokenStorage {
  protected key = 'ds365_token';
  protected token = '';
  constructor() { }

  get(): AuthToken | null {
    const token = this.token;
    const authToken = new AuthToken(token);
    try {
      return authToken;
    } catch (e) {}
    return null;
  }

  set(token: AuthToken) {
    this.token = token.getValue();
  }

  clear() {
    this.token = '';
  }
}
